import React, { useState } from 'react';
import { FaUniversity, FaUserTie, FaChartLine, FaCalculator, FaShieldAlt, FaUsers, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaBriefcase, FaGraduationCap, FaRupeeSign, FaHandHoldingUsd, FaBuilding, FaFileInvoice } from 'react-icons/fa';

const BankingPage = () => {
  const [expandedExam, setExpandedExam] = useState(null);
  const [expandedBank, setExpandedBank] = useState(null);
  const [expandedRole, setExpandedRole] = useState(null);

  const bankingExams = [
    {
      id: 'sbi-po',
      name: 'SBI PO (Probationary Officer)',
      icon: <FaUserTie />,
      bank: 'State Bank of India',
      eligibility: 'Graduate (Any Discipline)',
      ageLimit: '21-30 years',
      salary: '₹50,000 - ₹70,000/month',
      description: 'Premier officer cadre position in India\'s largest bank',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '1 hour', sections: 'English, Quantitative Aptitude, Reasoning' },
        { phase: 'Main Exam', type: 'Online Objective + Descriptive', duration: '3 hours', sections: 'Reasoning, English, Data Analysis, General Awareness, Computer, Descriptive' },
        { phase: 'Group Exercise & Interview', type: 'Group Discussion + Personal Interview', duration: 'Varies', sections: 'GD (20 marks) + PI (30 marks)' }
      ],
      careerPath: 'PO → Assistant Manager → Manager → Senior Manager → Chief Manager → Assistant General Manager → Deputy General Manager → General Manager'
    },
    {
      id: 'sbi-clerk',
      name: 'SBI Clerk (Junior Associate)',
      icon: <FaBriefcase />,
      bank: 'State Bank of India',
      eligibility: 'Graduate (Any Discipline)',
      ageLimit: '20-28 years',
      salary: '₹25,000 - ₹35,000/month',
      description: 'Clerical position handling customer service and transactions',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '1 hour', sections: 'English, Quantitative Aptitude, Reasoning' },
        { phase: 'Main Exam', type: 'Online Objective', duration: '2 hours 40 minutes', sections: 'General English, Quantitative Aptitude, Reasoning, General Awareness, Computer' }
      ],
      careerPath: 'Clerk → Senior Clerk → Head Cashier → Promotion to PO scale after experience'
    },
    {
      id: 'ibps-po',
      name: 'IBPS PO (Probationary Officer)',
      icon: <FaUserTie />,
      bank: 'All Public Sector Banks',
      eligibility: 'Graduate (Any Discipline)',
      ageLimit: '20-30 years',
      salary: '₹40,000 - ₹60,000/month',
      description: 'Common exam for PO recruitment in 11+ public sector banks',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '1 hour', sections: 'English, Quantitative Aptitude, Reasoning' },
        { phase: 'Main Exam', type: 'Online Objective + Descriptive', duration: '3 hours', sections: 'Reasoning, English, Data Analysis, General Awareness, Computer, Descriptive' },
        { phase: 'Interview', type: 'Personal Interview', duration: 'Varies', sections: '100 marks' }
      ],
      careerPath: 'Same as SBI PO career progression'
    },
    {
      id: 'ibps-clerk',
      name: 'IBPS Clerk',
      icon: <FaBriefcase />,
      bank: 'All Public Sector Banks',
      eligibility: 'Graduate (Any Discipline)',
      ageLimit: '20-28 years',
      salary: '₹20,000 - ₹30,000/month',
      description: 'Common exam for Clerk recruitment in public sector banks',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '1 hour', sections: 'English, Quantitative Aptitude, Reasoning' },
        { phase: 'Main Exam', type: 'Online Objective', duration: '2 hours 40 minutes', sections: 'General English, Quantitative Aptitude, Reasoning, General Awareness, Computer' }
      ],
      careerPath: 'Clerk → Promotion to Officer cadre possible'
    },
    {
      id: 'ibps-so',
      name: 'IBPS SO (Specialist Officer)',
      icon: <FaUserTie />,
      bank: 'All Public Sector Banks',
      eligibility: 'Graduate/Post Graduate (Specific discipline)',
      ageLimit: '20-30 years',
      salary: '₹30,000 - ₹70,000/month',
      description: 'Specialist positions in IT, Agriculture, Law, HR, Marketing, Rajbhasha',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '1 hour', sections: 'English, Reasoning, Quantitative Aptitude' },
        { phase: 'Main Exam', type: 'Online Objective', duration: '2 hours', sections: 'Professional Knowledge + General sections' },
        { phase: 'Interview', type: 'Personal Interview', duration: 'Varies', sections: '100 marks' }
      ],
      specializations: ['IT Officer', 'Agriculture Field Officer', 'Rajbhasha Adhikari', 'Law Officer', 'HR/Personnel Officer', 'Marketing Officer'],
      careerPath: 'SO Scale I → Scale II → Scale III → Scale IV → Scale V'
    },
    {
      id: 'ibps-rrb',
      name: 'IBPS RRB (Regional Rural Banks)',
      icon: <FaBuilding />,
      bank: 'Regional Rural Banks',
      eligibility: 'Graduate (Any Discipline)',
      ageLimit: '18-30 years',
      salary: '₹20,000 - ₹45,000/month',
      description: 'Officers and Office Assistants in Regional Rural Banks',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '45 minutes', sections: 'Reasoning, Quantitative Aptitude' },
        { phase: 'Main Exam', type: 'Online Objective', duration: '2 hours', sections: 'Reasoning, Quantitative Aptitude, General Awareness, English/Hindi, Computer' }
      ],
      careerPath: 'Office Assistant/Officer Scale I → Scale II → Scale III'
    },
    {
      id: 'rbi-grade-b',
      name: 'RBI Grade B Officer',
      icon: <FaChartLine />,
      bank: 'Reserve Bank of India',
      eligibility: 'Graduate (Minimum 60%)',
      ageLimit: '21-30 years',
      salary: '₹77,000 - ₹1,00,000/month',
      description: 'Most prestigious banking exam in India - Central Bank officers',
      examPattern: [
        { phase: 'Phase I', type: 'Online Objective', duration: '2 hours', sections: 'General Awareness, English, Quantitative Aptitude, Reasoning' },
        { phase: 'Phase II', type: 'Online Objective + Descriptive', duration: '3 hours', sections: 'Economic & Social Issues, English, Finance & Management' },
        { phase: 'Interview', type: 'Personal Interview', duration: 'Varies', sections: '50 marks' }
      ],
      careerPath: 'Grade B (Junior Management) → Grade A → Top Management → Executive Directors'
    },
    {
      id: 'rbi-assistant',
      name: 'RBI Assistant',
      icon: <FaBriefcase />,
      bank: 'Reserve Bank of India',
      eligibility: 'Graduate (Any Discipline)',
      ageLimit: '20-28 years',
      salary: '₹35,000 - ₹50,000/month',
      description: 'Support staff position in RBI',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '1 hour', sections: 'English, Quantitative Aptitude, Reasoning' },
        { phase: 'Main Exam', type: 'Online Objective', duration: '2 hours 15 minutes', sections: 'Reasoning, English, Quantitative Aptitude, General Awareness, Computer' },
        { phase: 'Language Proficiency Test', type: 'Regional Language', duration: '15 minutes', sections: 'Language Test' }
      ],
      careerPath: 'Assistant → Promotion opportunities to Officer grade'
    },
    {
      id: 'nabard-grade-a',
      name: 'NABARD Grade A & B',
      icon: <FaChartLine />,
      bank: 'National Bank for Agriculture and Rural Development',
      eligibility: 'Graduate/Post Graduate (Specific discipline)',
      ageLimit: '21-30 years',
      salary: '₹47,000 - ₹80,000/month',
      description: 'Officers in agriculture and rural development banking',
      examPattern: [
        { phase: 'Preliminary Exam', type: 'Online Objective', duration: '2 hours', sections: 'English, Reasoning, Quantitative Aptitude, General Awareness, Computer' },
        { phase: 'Main Exam', type: 'Online Objective + Descriptive', duration: '3 hours', sections: 'Economic & Social Issues, Agriculture & Rural Development' },
        { phase: 'Interview', type: 'Personal Interview', duration: 'Varies', sections: '25-50 marks' }
      ],
      careerPath: 'Grade B → Grade A → Chief Manager → Assistant General Manager'
    },
    {
      id: 'sidbi',
      name: 'SIDBI (Small Industries Development Bank)',
      icon: <FaBuilding />,
      bank: 'SIDBI',
      eligibility: 'Graduate/CA/ICWA/MBA',
      ageLimit: '21-35 years',
      salary: '₹50,000 - ₹70,000/month',
      description: 'Officers in industrial development banking',
      examPattern: [
        { phase: 'Phase I', type: 'Online Objective', duration: '2 hours', sections: 'English, Reasoning, Quantitative Aptitude, General Awareness' },
        { phase: 'Phase II', type: 'Descriptive + Interview', duration: 'Varies', sections: 'Essay Writing + Interview' }
      ],
      careerPath: 'Grade A → Grade B → Senior Management'
    }
  ];

  const jobRoles = [
    {
      id: 'po',
      title: 'Probationary Officer (PO)',
      grade: 'JMGS-I (Junior Management Grade Scale I)',
      icon: <FaUserTie />,
      responsibilities: [
        'Branch Operations Management',
        'Customer Relationship Management',
        'Loan Processing and Approval',
        'Team Management and Leadership',
        'Business Development',
        'Risk Assessment',
        'Policy Implementation',
        'Financial Analysis'
      ],
      skills: ['Leadership', 'Communication', 'Analytical Skills', 'Decision Making', 'Customer Service', 'Financial Knowledge'],
      growth: 'Fast track to senior management positions',
      workType: 'Manager-level position with branch responsibilities'
    },
    {
      id: 'clerk',
      title: 'Clerk/Junior Associate',
      grade: 'Clerical Cadre',
      icon: <FaBriefcase />,
      responsibilities: [
        'Customer Service at Counter',
        'Cash Handling',
        'Account Opening and Maintenance',
        'Data Entry',
        'Documentation',
        'Passbook Printing',
        'Cheque Processing',
        'Balance Maintenance'
      ],
      skills: ['Accuracy', 'Computer Skills', 'Customer Service', 'Attention to Detail', 'Cash Handling'],
      growth: 'Can be promoted to Officer cadre',
      workType: 'Front-office operational role'
    },
    {
      id: 'so',
      title: 'Specialist Officer (SO)',
      grade: 'JMGS-I to MMGS-III',
      icon: <FaLaptop />,
      specializations: [
        {
          name: 'IT Officer',
          requirements: 'B.E./B.Tech in CS/IT/Electronics',
          work: 'Software development, system maintenance, cybersecurity'
        },
        {
          name: 'Agriculture Field Officer',
          requirements: 'B.Sc. Agriculture/Related field',
          work: 'Agricultural loan assessment, field visits, rural banking'
        },
        {
          name: 'Law Officer',
          requirements: 'LLB Degree',
          work: 'Legal matters, documentation, compliance'
        },
        {
          name: 'HR Officer',
          requirements: 'MBA/Post Graduate in HR',
          work: 'Recruitment, training, employee relations'
        },
        {
          name: 'Marketing Officer',
          requirements: 'MBA in Marketing',
          work: 'Product promotion, customer acquisition, campaigns'
        },
        {
          name: 'Rajbhasha Adhikari',
          requirements: 'Post Graduate in Hindi',
          work: 'Implementation of official language policy'
        }
      ],
      skills: ['Domain Expertise', 'Technical Knowledge', 'Problem Solving', 'Communication'],
      growth: 'Vertical growth in specialized domain',
      workType: 'Specialized technical or professional role'
    },
    {
      id: 'ca',
      title: 'Credit Analyst',
      grade: 'Scale I-II',
      icon: <FaCalculator />,
      responsibilities: [
        'Credit Assessment',
        'Financial Statement Analysis',
        'Risk Evaluation',
        'Loan Documentation Review',
        'Credit Report Preparation',
        'Portfolio Monitoring'
      ],
      skills: ['Financial Analysis', 'Risk Assessment', 'Excel', 'Report Writing', 'Regulatory Knowledge'],
      growth: 'Credit Manager → Senior Credit Manager',
      workType: 'Analytical and assessment role'
    },
    {
      id: 'rm',
      title: 'Relationship Manager',
      grade: 'Scale I-II',
      icon: <FaHandHoldingUsd />,
      responsibilities: [
        'Client Relationship Management',
        'Portfolio Management',
        'Sales Targets Achievement',
        'Cross-selling Bank Products',
        'Customer Retention',
        'Business Development'
      ],
      skills: ['Sales Skills', 'Communication', 'Negotiation', 'Product Knowledge', 'Customer Service'],
      growth: 'Senior RM → Branch Sales Manager → Zonal Manager',
      workType: 'Sales and customer-facing role'
    },
    {
      id: 'auditor',
      title: 'Bank Auditor',
      grade: 'Scale II-III',
      icon: <FaFileInvoice />,
      responsibilities: [
        'Internal Audit',
        'Compliance Checking',
        'Risk Assessment',
        'Fraud Detection',
        'Report Generation',
        'Process Improvement Suggestions'
      ],
      skills: ['Auditing', 'Attention to Detail', 'Regulatory Knowledge', 'Excel', 'Report Writing'],
      growth: 'Chief Internal Auditor',
      workType: 'Audit and compliance role'
    }
  ];

  const syllabus = {
    quantitativeAptitude: {
      icon: <FaCalculator />,
      topics: [
        'Number Systems and Simplification',
        'Decimals, Fractions, LCM & HCF',
        'Ratio and Proportion',
        'Percentage',
        'Profit and Loss',
        'Simple and Compound Interest',
        'Average',
        'Time and Work',
        'Time, Speed and Distance',
        'Problems on Ages',
        'Mensuration (2D & 3D)',
        'Data Interpretation (Tables, Bar Graphs, Line Charts, Pie Charts)',
        'Algebra (Linear Equations, Quadratic Equations)',
        'Trigonometry (Basic)',
        'Probability',
        'Permutation and Combination',
        'Sequence and Series'
      ]
    },
    reasoning: {
      icon: <FaBook />,
      topics: [
        'Puzzles (Seating Arrangement, Floor-based, Box-based)',
        'Syllogism',
        'Blood Relations',
        'Direction Sense',
        'Coding-Decoding',
        'Inequality',
        'Order and Ranking',
        'Alphabet and Number Series',
        'Data Sufficiency',
        'Input-Output',
        'Logical Reasoning',
        'Statement and Assumptions',
        'Statement and Arguments',
        'Passage and Conclusions',
        'Cause and Effect',
        'Alphanumeric Series',
        'Verbal Reasoning'
      ]
    },
    english: {
      icon: <FaBook />,
      topics: [
        'Reading Comprehension',
        'Vocabulary (Synonyms, Antonyms)',
        'Grammar (Subject-Verb Agreement, Tenses)',
        'Fill in the Blanks',
        'Cloze Test',
        'Para Jumbles',
        'Sentence Improvement',
        'Error Spotting',
        'Phrase Replacement',
        'Idioms and Phrases',
        'One Word Substitution',
        'Sentence Rearrangement',
        'Active and Passive Voice',
        'Direct and Indirect Speech',
        'Paragraph Completion',
        'Column Match'
      ]
    },
    generalAwareness: {
      icon: <FaUniversity />,
      topics: [
        'Banking and Financial Awareness',
        'Current Affairs (Last 6 months)',
        'Indian Economy',
        'Banking Terms and Definitions',
        'RBI Policies and Functions',
        'Government Schemes',
        'Budget and Economic Survey',
        'International Organizations',
        'Awards and Honors',
        'Books and Authors',
        'Sports News',
        'National and International Events',
        'Banking History and Nationalization',
        'Important Days and Dates',
        'Capital Markets and Stock Exchanges',
        'Insurance and Mutual Funds',
        'Digital Banking and Fintech',
        'Basel Norms and NPAs'
      ]
    },
    computer: {
      icon: <FaLaptop />,
      topics: [
        'Computer Fundamentals',
        'Microsoft Office (Word, Excel, PowerPoint)',
        'Internet and Email',
        'Computer Hardware and Software',
        'Operating Systems (Windows, Linux basics)',
        'Computer Networks and Internet',
        'Database Management Systems',
        'Computer Security and Viruses',
        'HTML and Web Technologies',
        'Shortcuts and Abbreviations',
        'Digital Payment Systems',
        'Cloud Computing basics',
        'Artificial Intelligence and Machine Learning basics',
        'Cyber Security',
        'Blockchain and Cryptocurrency basics'
      ]
    }
  };

  const preparationRoadmap = [
    {
      phase: 'Phase 1: Foundation (Months 1-3)',
      duration: '3 Months',
      focus: 'Building strong basics',
      activities: [
        'Complete syllabus coverage',
        'Basic concept building in all sections',
        'Daily newspaper reading for current affairs',
        'Banking awareness basics',
        'Formula memorization for Quant',
        'Basic English grammar'
      ]
    },
    {
      phase: 'Phase 2: Practice (Months 4-6)',
      duration: '3 Months',
      focus: 'Speed and accuracy',
      activities: [
        'Topic-wise practice tests',
        'Previous year papers solving',
        'Speed improvement drills',
        'Error analysis',
        'Shortcut techniques learning',
        'Mock test series (sectional)'
      ]
    },
    {
      phase: 'Phase 3: Mock Tests (Months 7-9)',
      duration: '3 Months',
      focus: 'Exam simulation',
      activities: [
        'Full-length mock tests',
        'Time management practice',
        'Attempt strategy development',
        'Revision of weak areas',
        'Current affairs compilation',
        'Interview preparation basics'
      ]
    },
    {
      phase: 'Phase 4: Final Revision (Month 10-12)',
      duration: '2-3 Months',
      focus: 'Consolidation and confidence',
      activities: [
        'Quick revision of all topics',
        'Formula sheets and notes review',
        'Last 3-month current affairs intensive',
        'Mock test analysis',
        'Stress management',
        'Interview preparation intensive'
      ]
    }
  ];

  const banks = [
    { name: 'State Bank of India (SBI)', type: 'Public Sector', branches: '22,000+' },
    { name: 'Punjab National Bank (PNB)', type: 'Public Sector', branches: '10,000+' },
    { name: 'Bank of Baroda', type: 'Public Sector', branches: '8,500+' },
    { name: 'Canara Bank', type: 'Public Sector', branches: '9,000+' },
    { name: 'Union Bank of India', type: 'Public Sector', branches: '9,500+' },
    { name: 'Bank of India', type: 'Public Sector', branches: '5,000+' },
    { name: 'Indian Bank', type: 'Public Sector', branches: '3,000+' },
    { name: 'Central Bank of India', type: 'Public Sector', branches: '4,600+' },
    { name: 'Indian Overseas Bank', type: 'Public Sector', branches: '3,200+' },
    { name: 'UCO Bank', type: 'Public Sector', branches: '3,000+' },
    { name: 'Bank of Maharashtra', type: 'Public Sector', branches: '1,900+' },
    { name: 'Punjab & Sind Bank', type: 'Public Sector', branches: '1,500+' },
    { name: 'HDFC Bank', type: 'Private Sector', branches: '6,300+' },
    { name: 'ICICI Bank', type: 'Private Sector', branches: '5,300+' },
    { name: 'Axis Bank', type: 'Private Sector', branches: '4,700+' },
    { name: 'Kotak Mahindra Bank', type: 'Private Sector', branches: '1,600+' }
  ];

  const benefits = [
    'Excellent salary packages with regular increments',
    'Job security and stability',
    'Pension benefits (for public sector banks)',
    'Medical insurance for self and family',
    'Housing loan at subsidized rates',
    'Education loan for children',
    'Leave Travel Allowance (LTA)',
    'Dearness Allowance (DA)',
    'House Rent Allowance (HRA)',
    'Provident Fund (PF) and Gratuity',
    'Performance-based incentives',
    'Work-life balance',
    'Prestigious career',
    'Career growth opportunities',
    'Transfer options across India',
    'Training and skill development'
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'Comprehensive Study Material',
      description: 'Complete books, notes, and study material covering entire banking exam syllabus'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Test Series',
      description: 'Unlimited mock tests with detailed solutions and performance analysis'
    },
    {
      icon: <FaUsers />,
      title: 'Expert Faculty',
      description: 'Learn from experienced banking professionals and exam toppers'
    },
    {
      icon: <FaClock />,
      title: 'Flexible Batches',
      description: 'Morning, evening, and weekend batches available for working professionals'
    },
    {
      icon: <FaTrophy />,
      title: 'Interview Preparation',
      description: 'Mock interviews, GD practice, and personality development sessions'
    },
    {
      icon: <FaChartLine />,
      title: 'Current Affairs Updates',
      description: 'Daily current affairs, monthly compilations, and banking awareness updates'
    }
  ];

  const toggleExam = (id) => {
    setExpandedExam(expandedExam === id ? null : id);
  };

  const toggleBank = (type) => {
    setExpandedBank(expandedBank === type ? null : type);
  };

  const toggleRole = (id) => {
    setExpandedRole(expandedRole === id ? null : id);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">Banking Services Examination Training</h1>
              <p className="lead mb-4">
                Comprehensive coaching for all banking exams - SBI, IBPS, RBI, NABARD and more. Join India's most prestigious banking sector with excellent salary, job security, and career growth.
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Start Learning</button>
              <button className="btn btn-outline-light btn-lg px-4">Download Syllabus</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaUniversity size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-primary fw-bold mb-1">50,000+</h3>
              <p className="text-muted mb-0">Annual Vacancies</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-success fw-bold mb-1">12+</h3>
              <p className="text-muted mb-0">PSU Banks</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-info fw-bold mb-1">₹20K-1L</h3>
              <p className="text-muted mb-0">Salary Range/Month</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-warning fw-bold mb-1">Graduate</h3>
              <p className="text-muted mb-0">Minimum Qualification</p>
            </div>
          </div>
        </div>
      </div>

      {/* Banking Exams */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Major Banking Examinations</h2>
        <div className="row">
          <div className="col-12">
            {bankingExams.map((exam) => (
              <div key={exam.id} className="card mb-3 border-0 shadow-sm">
                <div 
                  className="card-header bg-light d-flex justify-content-between align-items-center"
                  onClick={() => toggleExam(exam.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="text-primary me-3" style={{ fontSize: '1.8rem' }}>
                      {exam.icon}
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold text-primary">{exam.name}</h5>
                      <small className="text-muted">{exam.bank} • {exam.description}</small>
                    </div>
                  </div>
                  {expandedExam === exam.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {expandedExam === exam.id && (
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Eligibility:</strong></p>
                        <p className="text-muted">{exam.eligibility}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Age Limit:</strong></p>
                        <p className="text-muted">{exam.ageLimit}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Salary:</strong></p>
                        <p className="text-success fw-bold">{exam.salary}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Bank:</strong></p>
                        <p className="text-muted">{exam.bank}</p>
                      </div>
                    </div>

                    <h6 className="fw-bold mb-3">Examination Pattern:</h6>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Phase</th>
                            <th>Type</th>
                            <th>Duration</th>
                            <th>Sections</th>
                          </tr>
                        </thead>
                        <tbody>
                          {exam.examPattern.map((pattern, idx) => (
                            <tr key={idx}>
                              <td className="fw-semibold">{pattern.phase}</td>
                              <td>{pattern.type}</td>
                              <td>{pattern.duration}</td>
                              <td>{pattern.sections}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {exam.specializations && (
                      <div className="mt-3">
                        <h6 className="fw-bold mb-3">Specializations Available:</h6>
                        <div className="d-flex flex-wrap gap-2">
                          {exam.specializations.map((spec, idx) => (
                            <span key={idx} className="badge bg-info">{spec}</span>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="mt-4">
                      <h6 className="fw-bold mb-2">Career Progression:</h6>
                      <p className="text-muted small">{exam.careerPath}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Job Roles */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Banking Job Roles & Responsibilities</h2>
          <div className="row">
            <div className="col-12">
              {jobRoles.map((role) => (
                <div key={role.id} className="card mb-3 border-0 shadow-sm">
                  <div 
                    className="card-header d-flex justify-content-between align-items-center"
                    onClick={() => toggleRole(role.id)}
                    style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                  >
                    <div className="d-flex align-items-center">
                      <div className="text-primary me-3" style={{ fontSize: '1.5rem' }}>
                        {role.icon}
                      </div>
                      <div>
                        <h5 className="mb-1 fw-bold">{role.title}</h5>
                        <small className="text-muted">{role.grade} • {role.workType}</small>
                      </div>
                    </div>
                    {expandedRole === role.id ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                  {expandedRole === role.id && (
                    <div className="card-body">
                      {role.responsibilities && (
                        <div className="mb-4">
                          <h6 className="fw-bold mb-3">Key Responsibilities:</h6>
                          <div className="row">
                            {role.responsibilities.map((resp, idx) => (
                              <div key={idx} className="col-md-6 mb-2">
                                <FaCheckCircle className="text-success me-2" size={12} />
                                <small>{resp}</small>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {role.specializations && (
                        <div className="mb-4">
                          <h6 className="fw-bold mb-3">Specializations:</h6>
                          {role.specializations.map((spec, idx) => (
                            <div key={idx} className="card mb-2 border-light">
                              <div className="card-body p-3">
                                <h6 className="text-primary mb-2">{spec.name}</h6>
                                <p className="mb-1 small"><strong>Requirements:</strong> {spec.requirements}</p>
                                <p className="mb-0 small"><strong>Work:</strong> {spec.work}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-6">
                          <h6 className="fw-bold mb-2">Required Skills:</h6>
                          <div className="d-flex flex-wrap gap-2">
                            {role.skills.map((skill, idx) => (
                              <span key={idx} className="badge bg-secondary">{skill}</span>
                            ))}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <h6 className="fw-bold mb-2">Career Growth:</h6>
                          <p className="text-muted small mb-0">{role.growth}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Syllabus Section */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Complete Syllabus Coverage</h2>
        <div className="row g-4">
          <div className="col-lg-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-primary text-white">
                <div className="d-flex align-items-center">
                  {syllabus.quantitativeAptitude.icon}
                  <h5 className="mb-0 ms-2">Quantitative Aptitude</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.quantitativeAptitude.topics.map((topic, idx) => (
                    <div key={idx} className="col-12 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-success text-white">
                <div className="d-flex align-items-center">
                  {syllabus.reasoning.icon}
                  <h5 className="mb-0 ms-2">Reasoning Ability</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.reasoning.topics.map((topic, idx) => (
                    <div key={idx} className="col-12 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-info text-white">
                <div className="d-flex align-items-center">
                  {syllabus.english.icon}
                  <h5 className="mb-0 ms-2">English Language</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.english.topics.map((topic, idx) => (
                    <div key={idx} className="col-12 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-warning text-dark">
                <div className="d-flex align-items-center">
                  {syllabus.generalAwareness.icon}
                  <h5 className="mb-0 ms-2">General Awareness</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.generalAwareness.topics.map((topic, idx) => (
                    <div key={idx} className="col-12 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-secondary text-white">
                <div className="d-flex align-items-center">
                  {syllabus.computer.icon}
                  <h5 className="mb-0 ms-2">Computer Knowledge</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.computer.topics.map((topic, idx) => (
                    <div key={idx} className="col-md-6 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Preparation Roadmap */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">12-Month Preparation Roadmap</h2>
          <div className="row g-4">
            {preparationRoadmap.map((phase, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow h-100">
                  <div className="card-header bg-gradient text-white" style={{ background: `linear-gradient(135deg, ${['#667eea', '#764ba2', '#f093fb', '#4facfe'][idx]} 0%, ${['#764ba2', '#667eea', '#4facfe', '#00f2fe'][idx]} 100%)` }}>
                    <h5 className="mb-1 fw-bold">{phase.phase}</h5>
                    <small>Duration: {phase.duration} | Focus: {phase.focus}</small>
                  </div>
                  <div className="card-body">
                    <h6 className="fw-bold mb-3">Key Activities:</h6>
                    <ul className="list-unstyled">
                      {phase.activities.map((activity, aIdx) => (
                        <li key={aIdx} className="mb-2">
                          <FaCheckCircle className="text-success me-2" />
                          {activity}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Banks List */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Banks Recruiting Through IBPS</h2>
        <div className="row g-3">
          {banks.map((bank, idx) => (
            <div key={idx} className="col-md-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center">
                    <FaBuilding className="text-primary me-3 flex-shrink-0" size={24} />
                    <div>
                      <h6 className="mb-1 fw-bold">{bank.name}</h6>
                      <small className="text-muted">{bank.type}</small>
                      <br />
                      <small className="text-info">{bank.branches} Branches</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Benefits of Banking Career</h2>
          <div className="row g-3">
            {benefits.map((benefit, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body d-flex align-items-center p-3">
                    <FaCheckCircle className="text-success me-3 flex-shrink-0" size={20} />
                    <p className="mb-0">{benefit}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Salary Comparison */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Salary Structure Comparison</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <FaBriefcase size={50} className="text-primary mb-3" />
              <h5 className="fw-bold">Clerk/Junior Associate</h5>
              <h3 className="text-success mb-2">₹20,000 - ₹35,000</h3>
              <p className="text-muted small">Per Month (Basic + Allowances)</p>
              <hr />
              <ul className="list-unstyled text-start small">
                <li className="mb-1">✓ Basic Pay: ₹19,900</li>
                <li className="mb-1">✓ DA: ₹7,000 (approx)</li>
                <li className="mb-1">✓ HRA: ₹4,000 (approx)</li>
                <li className="mb-1">✓ Other Allowances</li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <FaUserTie size={50} className="text-success mb-3" />
              <h5 className="fw-bold">Probationary Officer</h5>
              <h3 className="text-success mb-2">₹40,000 - ₹70,000</h3>
              <p className="text-muted small">Per Month (Basic + Allowances)</p>
              <hr />
              <ul className="list-unstyled text-start small">
                <li className="mb-1">✓ Basic Pay: ₹36,000</li>
                <li className="mb-1">✓ DA: ₹15,000 (approx)</li>
                <li className="mb-1">✓ HRA: ₹10,000 (approx)</li>
                <li className="mb-1">✓ Other Allowances</li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <FaChartLine size={50} className="text-info mb-3" />
              <h5 className="fw-bold">RBI Grade B Officer</h5>
              <h3 className="text-success mb-2">₹77,000 - ₹1,00,000</h3>
              <p className="text-muted small">Per Month (Basic + Allowances)</p>
              <hr />
              <ul className="list-unstyled text-start small">
                <li className="mb-1">✓ Basic Pay: ₹67,700</li>
                <li className="mb-1">✓ DA: ₹25,000 (approx)</li>
                <li className="mb-1">✓ HRA: ₹18,000 (approx)</li>
                <li className="mb-1">✓ Other Allowances</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Choose Our Banking Training?</h2>
          <div className="row g-4">
            {features.map((feature, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="text-primary mb-3" style={{ fontSize: '3rem' }}>
                    {feature.icon}
                  </div>
                  <h5 className="fw-bold mb-3">{feature.title}</h5>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Success Tips */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Success Tips for Banking Exams</h2>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card border-primary h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">For Preliminary Exam</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Speed is Key:</strong> Focus on solving questions quickly with accuracy
                  </li>
                  <li className="mb-3">
                    <strong>Attempt Strategy:</strong> Start with your strongest section
                  </li>
                  <li className="mb-3">
                    <strong>Shortcuts:</strong> Master shortcut techniques for calculation-heavy questions
                  </li>
                  <li className="mb-3">
                    <strong>Mock Tests:</strong> Take at least 50+ mock tests before exam
                  </li>
                  <li className="mb-3">
                    <strong>Time Management:</strong> Allocate 20 minutes per section
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-success h-100">
              <div className="card-header bg-success text-white">
                <h5 className="mb-0">For Main Exam</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Accuracy Matters:</strong> Main exam requires both speed and accuracy
                  </li>
                  <li className="mb-3">
                    <strong>Descriptive Paper:</strong> Practice essay and letter writing regularly
                  </li>
                  <li className="mb-3">
                    <strong>Banking Awareness:</strong> Read banking magazines and follow RBI policies
                  </li>
                  <li className="mb-3">
                    <strong>Current Affairs:</strong> Last 6 months current affairs are crucial
                  </li>
                  <li className="mb-3">
                    <strong>Revision:</strong> Focus on quick revision 15 days before exam
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-5">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Start Your Banking Career?</h2>
            <p className="lead mb-4">
              Join our comprehensive training program and secure your position in India's top banks
            </p>
            <button className="btn btn-light btn-lg px-5 me-3">Enroll Now</button>
            <button className="btn btn-outline-light btn-lg px-5">Book Free Demo</button>
          </div>
        </div>
      </div>

     
    </div>
  );
};

export default BankingPage;